module.exports = __webpack_public_path__ + "img/avatar.0cec2ded.png";